<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/ventatiposadjuntos`;

function authHeaders() {
  return {
    'Authorization': `Bearer ${utilsService.getToken()}`,
  };
}

async function getAll() {
  const response = await axios.get(apiUrl, { headers: authHeaders() });
  return response.data;
}

export default {
  getAll,
};
</script>
